export default __webpack_public_path__ + "static/banner-documentation-1-006ea65e4de9117f0f568fecad9ae0bc.jpg";